import { render, staticRenderFns } from "./SwapsNewInvoices.vue?vue&type=template&id=aa68c152"
import script from "./SwapsNewInvoices.vue?vue&type=script&lang=ts"
export * from "./SwapsNewInvoices.vue?vue&type=script&lang=ts"
import style0 from "./SwapsNewInvoices.vue?vue&type=style&index=0&id=aa68c152&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports